import { useTranslation } from 'react-i18next'

import { Post } from 'lib/_types'
import {
  usePinnedPostDeleteMutation,
  usePinnedPostGroupDeleteMutation,
} from 'store/api/yay/timeline'

import ConfirmBoxBasic from 'components/ConfirmBoxBasic'

const ConfirmBoxUnPinPost = ({
  isActive,
  onClose,
  data,
}: {
  isActive: boolean
  onClose: any
  data: {
    groupId: number
    post: Post
    onUnpinPostCallback?: Function
  }
}) => {
  const { t } = useTranslation()

  const [pinnedPostGroupDelete] = usePinnedPostGroupDeleteMutation()
  const [pinnedPostDelete] = usePinnedPostDeleteMutation()

  const onConfirm = async () => {
    const { groupId } = data

    try {
      if (groupId) {
        await pinnedPostGroupDelete({
          groupId,
        })
      } else {
        await pinnedPostDelete({
          postId: data?.post?.id,
        })
      }
    } finally {
      data?.onUnpinPostCallback?.()
      onClose()
    }
  }

  return (
    <ConfirmBoxBasic
      isActive={isActive}
      onClose={onClose}
      onOk={onConfirm}
      title={t('confirm_box_unpin_post.title')}
      content={t('confirm_box_unpin_post.content')}
      onCancel={onClose}
    />
  )
}

export default ConfirmBoxUnPinPost
